<template>
  <b-row>
    <b-col md="12">
      <b-form-group label="ROLES" description="Todo el staff que tenga usuario asignado y alguno de estos roles, va a recibir la notificación interna">
        <v-select :options="arr.select.roles" v-model="crud.form.roles_notification" placeholder="Roles" :multiple="true" :select-on-tab="true" @input="emitChange()"></v-select>
      </b-form-group>
    </b-col>
    <b-col md="12">
      <b-form-group label="STAFF" description="Todo el staff seleccionado va a recibir la notificación interna">
        <v-select :options="arr.select.staff" v-model="crud.form.staff_notification" placeholder="Staff" :multiple="true" :select-on-tab="true" @input="emitChange()"></v-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'

  export default {
    props: {
      roles_notification: {
        type: Array,
        default: null,
      },
      staff_notification: {
        type: Array,
        default: null,
      },
    },
    data: () => {
      return {
        crud: {
          form: {
            roles_notification: [],
            staff_notification: [],
          }
        },
        arr: {
          select: {
            roles: [],
            staff: []
          }
        }
      }
    },
    mounted() {
      this.getRoles()
      this.getStaff()

      this._start = true
    },
    activated() {
      if (this._start) {
        this._start = false
        return
      }

      this.getRoles()
      this.getStaff()
    },
    methods: {
      getStaff() {
        serviceAPI.obtenerStaff().then(response => {
          var data = response.data

          data.forEach(element => {
            this.arr.select.staff.push({code: element.id, label: element.name})
          });

          if (this.staff_notification) {
            this.staff_notification.forEach(element => {
              this.crud.form.staff_notification.push({code: element, label: this.getName('staff', element)})
            });
          }
        })
      },
      getRoles() {
        serviceAPI.obtenerRoles().then(response => {
          var data = response.data

          data.forEach(element => {
            this.arr.select.roles.push({code: element.id, label: element.name})
          });

          if (this.roles_notification) {
            this.roles_notification.forEach(element => {
              this.crud.form.roles_notification.push({code: element, label: this.getName('roles', element)})
            });
          }
        })
      },
      emitChange() {
        this.$emit('select-recipients', this.crud.form)
      },
      getName(type, code) {
        var name = ''
        if (type == 'roles') {
          this.arr.select.roles.forEach(element => {
            if (element.code == code) {
              name = element.label
            }
          });
        }
        if (type == 'staff') {
          this.arr.select.staff.forEach(element => {
            if (element.code == code) {
              name = element.label
            }
          });
        }
        return name
      }
    }
  }
</script>
